import axios from "axios";
// import { message } from "../constants/message";
import { message } from "./message";
import { toast } from "react-toastify";
import swal from "sweetalert";
// import { STATUS_CODE } from "../constants";
import { STATUS_CODE } from "../utils/constValue";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
axios.defaults.headers.post["Accept"] = "*/*";
axios.defaults.headers.post["Access-Control-Allow-Origin"] =
  process.env.REACT_APP_CLIENT_URL || "*";
axios.defaults.headers["Authorization"] = localStorage.getItem(
  "access_token_bccu",
)
  ? "Bearer " + localStorage.getItem("access_token_bccu")
  : "";

const ApiCustom = axios.create({
  baseURL:
    `${process.env.REACT_APP_API_URL}api` ||
    "https://03q2rwl7-9000.asse.devtunnels.ms/",
  timeout: 60000,
});

ApiCustom.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const statusCode = error.response.status;
      if (statusCode === STATUS_CODE.FORBIDDEN) {
        toast(message.forbiddenError, { type: "error" });
      } else if (statusCode === STATUS_CODE.INTERNAL_SERVER_ERROR) {
        toast(message.internalServerError, { type: "error" });
      } else if (statusCode === STATUS_CODE.UNAUTHORIZED) {
        return swal({
          title: "Lỗi 401!",
          text:
            error.response?.data?.messages ||
            message.unauthorizedError ||
            "Vui lòng đăng nhập",
          icon: "error",
          successMode: true,
        }).then((ok) => {
          if (ok) {
            localStorage.removeItem("access_token_bccu");
            localStorage.removeItem("permissions");
            localStorage.removeItem("userId");
            localStorage.removeItem("full_name");
            window.location.href = "/login";
          }
        });
      }
    } else {
      switch (error.code) {
        case "ERR_NETWORK":
          toast(message.networkError, { type: "error" });
          break;
        case "ECONNABORTED":
          toast(message.timeoutError, { type: "error" });
          break;
        default:
          toast(error.message, { type: "error" });
      }
    }
    return Promise.reject(error);
  },
);

export default ApiCustom;
